import { useFiltersObservable } from './useFiltersObservable';
import { useMemo } from 'react';

const emptyFilter = { id: '', value: '' };

export const useSelectedFilters = () => {
  const { data: selectedFiltersRaw = [] } = useFiltersObservable();

  return useMemo(() => {
    const getFilterByIndex = (idx: number) => {
      const filter = selectedFiltersRaw[idx];
      return filter
        ? {
            id: filter.id,
            value: filter.name,
          }
        : emptyFilter;
    };

    return {
      client: getFilterByIndex(0),
      region: getFilterByIndex(1),
      country: getFilterByIndex(2),
      brandCategory: getFilterByIndex(3),
      brand: getFilterByIndex(4),
      product: getFilterByIndex(5),
    };
  }, [selectedFiltersRaw]);
};

export const useSelectedFilterValues = () => {
  const selectedFilters = useSelectedFilters();

  return useMemo(() => {
    return Object.entries(selectedFilters).reduce((acc, [key, item]) => {
      acc[key as keyof ReturnType<typeof useSelectedFilters>] = item.value;
      return acc;
    }, {} as { [key in keyof ReturnType<typeof useSelectedFilters>]: string });
  }, [selectedFilters]);
};

export const useSelectedFilterIds = () => {
  const selectedFilters = useSelectedFilters();

  return useMemo(() => {
    return Object.entries(selectedFilters).reduce((acc, [key, item]) => {
      acc[`${key}Id` as `${keyof ReturnType<typeof useSelectedFilters>}Id`] =
        item.id;
      return acc;
    }, {} as { [key in keyof ReturnType<typeof useSelectedFilters> as `${key}Id`]: string });
  }, [selectedFilters]);
};
